export function AuthToken(): { Authorization: string, "Content-Type": string } | undefined {
  const accessToken = localStorage.getItem("accessToken");

  if (!accessToken?.length) return;

  return {
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": 'application/json'
  };
}

export function SetAuth(accessToken: string): void {
  localStorage.setItem("accessToken", accessToken);
}

export function Logout(): void {
  localStorage.setItem("accessToken", "");
  window.location.href = "/login";
}
